
export function dispatch(name, ...args) {
  document.dispatchEvent(new CustomEvent(name, { detail: args }));
}
export function listen(name, callback) {
  document.addEventListener(name, event => {
    callback(...event.detail);
  });
}
